import * as React from 'react';

export interface SwitchContainerContextValues {
    setFocused: React.Dispatch<React.SetStateAction<boolean>> | null;
    setChecked: React.Dispatch<React.SetStateAction<boolean>> | null;
}

export const SwitchContainerContext = React.createContext<SwitchContainerContextValues>({
    setFocused: null,
    setChecked: null,
});

export function useSwitchContainer(): SwitchContainerContextValues {
    return React.useContext(SwitchContainerContext);
}
